import { action, computed, observable, makeObservable } from 'mobx';
import type { SelectInputOption } from '../../components/input/input.select';
import { Services } from '../../services';

export class OrgDepartmentSelectorCtrl {
	includeOtherOrgs;
	constructor(includeOtherAdminOrgs = false) {
		makeObservable(this);

		this.includeOtherOrgs = includeOtherAdminOrgs;
	}
	@observable selectedDepartmentId: string | null = null;

	@computed get loadingDepartments(): boolean {
		return Services.Department.current != null && Services.Department.departments.length === 0;
	}

	@computed get departmentOptions(): SelectInputOption[] {
		const currentDepartment = Services.Department.current;
		if (currentDepartment == null || currentDepartment.orgId == null) {
			return [];
		}

		const moveableDepartments = Services.Department.moveableDepartments();

		// For some weird reason office uses the key as the display, and its value as its key on the <option> element????
		return moveableDepartments.map((department) => ({
			key: `${department.displayName}${currentDepartment.orgId === department.orgId ? '' : ' (Outside Org)'}`,
			value: department.objectId,
		}));
	}

	@action selectDepartment(departmentId: string) {
		this.selectedDepartmentId = departmentId;
	}
}
